<template>
	<div class="content-class">
		<v-tabs color="black" dark slider-color="primary">
			<v-tab ripple>Ajouter un groupe de bot</v-tab>
		</v-tabs>
		<bot-groups-form v-model="document" />
	</div>
</template>

<script>
import BotGroupsForm from '../../components/botGroups/botGroups.form'

export default {
	components: { BotGroupsForm },
	data() {
		return {
			document: {
				name: '',
				key: '',
				bots: [],
			},
		}
	},
}
</script>

<style lang="scss">
.content-class {
	width: 100%;
	height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/botGroups/botGroups.add.vue